import {Box, Split, withShade} from '@dropbox/dig-foundations';
import {ReactNode} from 'react';

/** Shared padded row shell for list-style dashboard tiles. */
export const TileListRow = ({
  children,
  trailing,
  trailingAlignY = 'top',
  shade,
  interactive,
}: {
  children: ReactNode;
  trailing?: ReactNode;
  trailingAlignY?: 'top' | 'center';
  shade?: ReturnType<typeof withShade>;
  interactive?: boolean;
}) => {
  const rowShade =
    shade ??
    withShade({
      style: {
        marginInline: -8,
        ...(interactive ? {cursor: 'pointer'} : {}),
      },
    });

  return (
    <Box
      className={rowShade.className}
      style={rowShade.style}
      paddingX="8"
      paddingY="6"
      borderRadius="Medium"
    >
      {trailing ? (
        <Split gap="8" alignY={trailingAlignY}>
          <Split.Item width="fill" style={{minWidth: 0, overflow: 'hidden'}}>
            {children}
          </Split.Item>
          <Split.Item style={{flexShrink: 0}}>{trailing}</Split.Item>
        </Split>
      ) : (
        children
      )}
    </Box>
  );
};
